<template>
  <template v-if="type=='money'">
    {{common.formatCurrency2($store.state.preload["/currency"], value)}}
  </template>
  <template v-else>
    {{value}}
  </template>
</template>

<script>
export default {

  name: "CellValue",
  
  props: {
    value: [Number, String, Boolean, Array],
    type: String,
  },
  
  created()
  {
    this.ensure("currency")
  },
  
}
</script>
